import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import PaymentTypeForm from '../../../components/forms/PaymentTypeForm';
import { usePaymentTypeById, useUpdatePaymentType } from '../../../hooks/usePaymentTypeApi';
import { useNavigate, useParams } from 'react-router-dom';
import { PaymentTypeDTO } from '../../../services/apiClient';

const PaymentTypeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = usePaymentTypeById(id!);
  const updateMutation = useUpdatePaymentType();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Payment Types', href: '/admin/paymenttypes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/paymenttypes');
    } catch (error) {
      console.error('Error updating PaymentType:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/paymenttypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.PaymentType.Edit'
    >
        {entityData ? (
          <PaymentTypeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/paymenttypes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default PaymentTypeEdit;